export default __webpack_public_path__ + "static/media/photo_gallery_9.4747a7f7.png";